import React from "react";

/**
 * BlueSuggestions — chips cliquables pour amorcer une conversation.
 * Rendues uniquement avant la première interaction utilisateur.
 */
export function BlueSuggestions({ suggestions, label, onPick, disabled }) {
  if (!suggestions || suggestions.length === 0) return null;
  return (
    <div className="blue-suggestions" data-testid="blue-suggestions">
      <div className="blue-suggestions__label">{label}</div>
      <div className="blue-suggestions__list">
        {suggestions.map((s, i) => (
          <button
            key={i}
            type="button"
            className="blue-suggestions__chip"
            onClick={() => onPick(s)}
            disabled={disabled}
            data-testid={`blue-suggestion-${i}`}
          >
            {s}
          </button>
        ))}
      </div>
    </div>
  );
}

export default BlueSuggestions;
